
import React from "react";
import {Link} from "react-router-dom";

export default function LinkToMainPage() {
    return (<Link className="tilbake-link" to="/">
        &lt; &nbsp;Tilbake til forsiden
    </Link>)
}